<template>
    <div :style="welcome" class="welcome">
        <v-container fluid>

            <div :style="logoStyle" class="logo-container">

                <!-- Desktop -->
                <div v-if="!xs" class="logo-wrapper-desktop">
                    <v-img :src="logoWhite" alt="Logo" class="logo-desktop" />
                    <div class="logo-caption">
                        <div class="caption-line-1">Creación y diseño: Jorge Juárez González</div>
                        <div class="caption-line-2">Programación: Eduardo Gutiérrez Lariz y</div>
                        <div class="caption-line-2">Ulises Oldemar Ortega Gutierrez</div>
                    </div>
                </div>

                <!-- Mobile -->
                <div v-else class="logo-wrapper-mobile">
                    <v-img :src="logo" alt="Logo" class="logo-mobile" />
                    <div class="logo-caption">
                        <div class="caption-line-1">Creación y diseño: Jorge Juárez González</div>
                        <div class="caption-line-2">Programación: Eduardo Gutiérrez Lariz y</div>
                        <div class="caption-line-2">Ulises Oldemar Ortega Gutierrez</div>
                    </div>
                </div>

            </div>

            <!-- <v-row justify="end" :style="logoStyle">
                <v-col cols="12" md="4" sm="6" xs="12">
                    
                </v-col>
            </v-row> -->
            <div>
                <v-row :style="textAlign">
                    <v-col cols="12" md="5" sm="6" xs="12" :style="centerText">
                        <p v-if="!xs" class="text-h3 font-weight-bold text-center" style="color: #39343E;">Play And Sail
                        </p>
                        <p v-else class="text-h4 font-weight-bold text-center" style="color: #39343E;">Play And Sail</p>
                    </v-col>
                </v-row>
                <v-row justify="start" :style="textAlign">
                    <v-col cols="12" md="5" sm="6" xs="12" class="text-center">
                        <p>
                            Bienvenido a la plataforma la cual te ayudará a ofrecer una visión valiosa sobre las
                            habilidades cognitivas de las personas
                        </p>
                    </v-col>
                </v-row>
                <v-row justify="start" :style="textAlign">
                    <v-col cols="12" md="5" sm="6" xs="12" class="text-center">
                        <div>
                            <router-link to="/login">
                                <v-btn color="primary" class="ma-4">Inicia sesión</v-btn>
                            </router-link>
                            <router-link to="/join-room">
                                <v-btn color="primary" class="ma-4">Únete a una sala</v-btn>
                            </router-link>
                        </div>
                    </v-col>
                </v-row>
            </div>

        </v-container>
    </div>
</template>

<script setup>
import { computed, } from 'vue';
// import logo from "@/assets/images/Logo.svg";
// import logoWhite from "@/assets/images/Logo-White.svg";
import logo from "@/assets/images/Logo-Sail.svg";
import logoWhite from "@/assets/images/Logo-White-Sail.svg";
import { useDisplay } from 'vuetify/lib/framework.mjs';

const { xs, mdAndUp, sm } = useDisplay()

const logoStyle = computed(() => ({
    margin: mdAndUp.value ? '5% 5% 0px 0px' : '15% 0px 13% 0px',
}));

const welcome = computed(() => ({
    backgroundPosition: xs.value ? 'left' : 'center',
}));

const centerText = computed(() => ({
    marginTop: mdAndUp.value ? '14%' : '12%',
}));

const textAlign = computed(() => {
    const styles = {};

    if (mdAndUp.value) {
        styles.marginLeft = '7.5%';
        return styles;
    }

    if (sm.value) {
        styles.marginLeft = '4%';
        return styles;
    }

    styles.marginLeft = '0px';
    styles.marginRight = '0px';
    return styles;
});

</script>

<style scoped>
.welcome {
    height: 100vh;
    background: #f0f0f0 url('@/assets/images/Welcome-Banner.png') no-repeat fixed;
    background-size: cover;
}

.logo-container {
    position: relative;
}

/* ===== Desktop ===== */
.logo-wrapper-desktop {
    position: absolute;
    right: 5%;
    top: 5%;
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo-desktop {
    width: 100%;
}

/* ===== Mobile ===== */
.logo-wrapper-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo-mobile {
    width: 75%;
}

/* ===== Caption ===== */
.logo-caption {
    margin-top: 12px;
    text-align: center;
}

.caption-line-1 {
    font-weight: bold;
    font-size: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.caption-line-2 {
    font-size: 20px;
    opacity: 0.9;
}

/* ===== Desktop ===== */
.logo-wrapper-desktop .logo-caption {
  color: white;
}

.logo-wrapper-desktop .caption-line-1 {
  font-weight: bold;
  font-size: 24px;
  white-space: nowrap;
}

.logo-wrapper-desktop .caption-line-2 {
  font-size: 20px;
  opacity: 0.9;
}

/* ===== Mobile ===== */
.logo-wrapper-mobile .logo-caption {
  color: #39343E;
}

.logo-wrapper-mobile .caption-line-1 {
  font-weight: bold;
  font-size: 16px;   /* 🔥 más pequeño */
  white-space: nowrap;
}

.logo-wrapper-mobile .caption-line-2 {
  font-size: 14px;   /* 🔥 aún más pequeño */
  opacity: 0.85;
}


</style>